import {
  Box,
  Button,
  CardMedia,
  Container,
  FormControl,
  FormGroup,
  FormLabel,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { object, ref, setLocale, string } from "yup";
import { useFormik } from "formik";
import ErrorMessageTypo from "../../components/form/ErrorMessageTypo";
import { en } from "yup-locales";
import { RequestHelper } from "../../utils/requestHelper";
import { _ROUTES } from "../../utils/_routes_constants";
import { createToast } from "../../utils/toast";
import { _ACTIONS } from "../../utils/constants";

export const SetPassword = () => {
  const token = window.location.pathname.split("/")[2];
  const rq = new RequestHelper();

  const v = object({
    password_first: string().required("Please enter your password"),
    password_sec: string()
      .required("Please re-enter your password to confirm")
      .oneOf([ref("password_first"), null], "Passwords do not match"),
  });

  setLocale(en);

  const formik = useFormik({
    initialValues: {
      password_first: "",
      password_sec: "",
    },
    validationSchema: v,
    onSubmit: (values) => {
      const data = {
        password: values.password_first,
        resetPasswordToken: token,
      };

      rq.doRequest(_ACTIONS.POST, _ROUTES.SET_PASSWORD, data).then((res) => {
        if (res.status === 200) {
          createToast(
            "success",
            "Your password has been successfully changed",
            4000
          ).then(() => {
            window.location.href = "/";
          });
        }
      });
    },
  });

  return (
    <>
      <Container component="main">
        <form id="setPassword" onSubmit={formik.handleSubmit}>
          <Box
            display={"flex"}
            sx={{
              height: "100vh",
            }}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid2
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid2 size={8}></Grid2>
              <Grid2 size={4}>
                <CardMedia
                  component="img"
                  className="ubplogo"
                  image={process.env.PUBLIC_URL + "/img/logo_ubp.png"}
                  sx={{
                    borderRadius: "10px",
                  }}
                />
              </Grid2>
              <Grid2
                size={8}
                sx={{
                  height: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{
                    borderRadius: "10px",
                    height: "100%",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.25)",
                  }}
                  className="ubplogo"
                  image={process.env.PUBLIC_URL + "/img/accueil.png"}
                />
              </Grid2>
              <Grid2 size={4} sx={{ height: "30vh" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    border: "1px solid black",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.25)",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      padding: "10px",
                    }}
                  >
                    <Typography variant={"body"} sx={{ fontWeight: "bold" }}>
                      Change or enter your password
                    </Typography>
                  </Box>

                  <Box sx={{ padding: "25px" }}>
                    <Box sx={{ mb: 2 }}>
                      <FormGroup>
                        <FormControl>
                          <FormLabel
                            sx={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              fontFamily: "Poppins, light[300], sans-serif",
                            }}
                          >
                            Password
                          </FormLabel>
                          <TextField
                            type={"password"}
                            size={"small"}
                            values={formik.values.password_first}
                            onChange={formik.handleChange}
                            placeholder={"********"}
                            name={"password_first"}
                            error={formik.errors.password_first ? true : false}
                          />
                          {formik.errors.password_first ? (
                            <ErrorMessageTypo
                              error={formik.errors.password_first}
                            />
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </Box>
                    <Box>
                      <FormGroup>
                        <FormControl fullWidth>
                          <FormLabel
                            sx={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              fontFamily: "Poppins, light[300], sans-serif",
                            }}
                          >
                            Please re-enter your password
                          </FormLabel>
                          <TextField
                            name={"password_sec"}
                            size={"small"}
                            values={formik.values.password_sec}
                            onChange={formik.handleChange}
                            placeholder={"********"}
                            type={"password"}
                            error={formik.errors.password_sec ? true : false}
                          />
                          {formik.errors.password_sec ? (
                            <ErrorMessageTypo
                              error={formik.errors.password_sec}
                            />
                          ) : null}
                        </FormControl>
                      </FormGroup>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"end"}
                    >
                      <Button
                        type="submit"
                        color="grey"
                        variant="contained"
                        form="setPassword"
                        sx={{
                          mt: 2,
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid2>
            </Grid2>
            <Typography
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "center",
                fontSize: "9px",
                fontStyle: "italic",
              }}
            >
              V.{process.env.REACT_APP_VERSION} Toolapp 2025
            </Typography>
          </Box>
        </form>
      </Container>
    </>
  );
};
